import * as angular from 'angular';

export interface StorageFcfsRequestResource
    extends ng.resource.IResourceClass<
        ng.resource.IResource<StorageFcfsRequestDto>
    > {
    checkAvailability: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageFcfsRequestDto>
    >;
    test: ng.resource.IResourceMethod<ng.resource.IResource<void>>;
    getResponseForRequest: ng.resource.IResourceMethod<
        ng.resource.IResource<StorageFcfsResponseDto>
    >;
}

function storageFcfsRequestResource(
    $resource: ng.resource.IResourceService,
    API_URL
): StorageFcfsRequestResource {
    return <StorageFcfsRequestResource>$resource(
        API_URL.STORAGE_FCFS_REQUEST,
        {},
        {
            checkAvailability: {
                method: 'POST',
                url: API_URL.STORAGE_FCFS_REQUEST + '/check-availability'
            },
            getResponseForRequest: {
                method: 'GET',
                url: API_URL.STORAGE_FCFS_REQUEST + '/:id/response'
            }
        }
    );
}

angular
    .module('app')
    .factory('storageFcfsRequestResource', storageFcfsRequestResource);
